import { addTableWrappers } from './add-table-wrappers'

if (document.querySelector('table')) {
  addTableWrappers()
}
